<template>
    <div>
        <div class="title">
            <div class="text mb-0">PetCare Widget</div>
        </div>

        <loader-list v-if="isLoading" />
        <div v-else-if="isNoConfig">
            Couldn't get PetCare Widget. Please reload this page or contact
            DaySmart Vet for support.
        </div>
        <div v-else>
            <!-- About Widget -->
            <div class="title">
                <div class="text">About Widget</div>
            </div>

            <div class="group-holder mb-3">
                The widget is a tool that allows people visiting your clinic's
                website to register as clients. It helps both new and existing
                clients enter their contact information, verify their identify,
                and find nearby clinics.
            </div>

            <!-- Embed A Button -->
            <div class="title">
                <div class="text">Embed A Button</div>
            </div>
            <div class="group-holder mb-3">
                We have provided the code below for you to place on your
                website, and it will display a button.<br />When the button is
                click, it will take the user to the PetCare page. <br /><br />
                You can also change the appearance of the button with the
                configuration below.
                <br /><br />
                <div class="mt-2 content">
                    <div class="row card p-3">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label for="btncolor">Button Color</label>
                                </div>
                                <div class="col-sm-8">
                                    <span id="btncolor">
                                        <color-picker
                                            :selectedColor="
                                                settings.button_color
                                            "
                                            @updateSelectedColor="
                                                data =>
                                                    (this.settings.button_color = data)
                                            "
                                        />
                                    </span>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-sm-4">
                                    <label for="btncolor">Font Color</label>
                                </div>
                                <div class="col-sm-8">
                                    <span id="btncolor">
                                        <color-picker
                                            :selectedColor="settings.font_color"
                                            @updateSelectedColor="
                                                data =>
                                                    (this.settings.font_color = data)
                                            "
                                        />
                                    </span>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-sm-4">
                                    <label for="btnsize">Button Size</label>
                                </div>
                                <div class="col-sm-8">
                                    <div class="d-flex align-items-center">
                                        <div class="pr-3">
                                            <dropdown
                                                :btnContent="
                                                    btnSizeSelected.label
                                                "
                                                :itemList="btnSizeOption"
                                                @selected="btnSizeSelect"
                                            ></dropdown>
                                        </div>

                                        <div class="d-flex align-items-center">
                                            Font Size
                                            <input
                                                id="fontSize"
                                                name="fontSize"
                                                class="form-control mx-1"
                                                type="number"
                                                :disabled="!isCustom"
                                                v-model="
                                                    settings.button_size
                                                        .fontSize
                                                "
                                                style="width: 60px;"
                                                v-validate="
                                                    'required|min_value:12'
                                                "
                                                :class="{
                                                    'border-danger': errors.has(
                                                        'fontSize'
                                                    )
                                                }"
                                            />
                                            px
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-sm-4">
                                    <label for="btncolor">Label</label>
                                </div>
                                <div class="col-sm-8">
                                    <span id="btncolor">
                                        <input
                                            v-model="settings.label"
                                            class="form-control"
                                        />
                                    </span>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-sm-4">
                                    <label for="btncolor">Return URL</label>
                                </div>
                                <div class="col-sm-8">
                                    <div id="btncolor">
                                        <input
                                            v-model="settings.return_url"
                                            placeholder="(Optional)"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="text-muted mt-1">
                                        This URL is where your users will be
                                        taken if they do not wish to proceed
                                        with the booking.
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="title">
                                        <div class="text">Preview</div>
                                    </div>
                                    <div class="group-holder mb-3">
                                        <div class="mt-2 content">
                                            <a
                                                :href="standalone_url"
                                                target="_blank"
                                            >
                                                <button
                                                    class="btn"
                                                    :style="`background-color:${settings.button_color}; 
                                                        color:${settings.font_color};
                                                        font-size:${settings.button_size.fontSize}px; `"
                                                >
                                                    {{ settings.label }}
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-sm-12 text-right">
                            <button
                                type="button"
                                class="btn mr-2"
                                style="background-color: #e1e1e1;"
                                :disabled="isSave"
                                @click="getPortalUrl"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn"
                                style="background-color: #180f29; color: white;"
                                :disabled="isSave"
                                @click="save"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Preview -->

            <!-- Code -->
            <div class="title">
                <div class="text">Code</div>
            </div>
            <div class="group-holder mb-3">
                Copy and paste the code below into your website to embed the
                button.
                <div class="mt-2 content">
                    <textarea
                        id="code_url"
                        v-model="code_url"
                        name="code_url"
                        class="form-control"
                        type="text"
                        readonly
                    ></textarea>
                    <div class="mt-2 text-right">
                        <a href="#" @click.prevent="copyToClipboard(code_url)"
                            >Click to copy</a
                        >
                    </div>
                </div>
            </div>

            <!-- Standalone URL -->
            <div class="title">
                <div class="text">Standalone URL</div>
            </div>
            <div class="group-holder">
                Alternatively, you can use this link to share it with anyone,
                including on your social media pages.
                <div class="mt-2 content">
                    <textarea
                        id="standalone_url"
                        v-model="standalone_url"
                        name="standalone_url"
                        class="form-control"
                        type="text"
                        readonly
                    ></textarea>
                    <div class="mt-2 text-right">
                        <a
                            href="#"
                            @click.prevent="copyToClipboard(standalone_url)"
                            >Click to copy</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoaderList from "@/components/elements/loader-list";
import SettingPetcare from "@/services/setting/petcare";
import Dropdown from "@/components/commons/dropdown.vue";
import ColorPicker from "@/components/commons/color-picker.vue";
import { find } from "lodash";

const PETCARE_WIDGET = "petcare_widget";

export default {
    components: {
        LoaderList,
        Dropdown,
        ColorPicker
    },
    data() {
        return {
            isLoading: false,
            isNoConfig: true,
            settings: {
                button_color: "#698E3C",
                font_color: "#FFFFFF",
                button_size: {
                    options: "large",
                    fontSize: 16
                },
                label: "Book Appointment",
                return_url: ""
            },
            standalone_url: "",
            code_url: "",
            btnSizeSelected: {
                label: "Large",
                value: "large",
                fontSize: 16
            },
            btnSizeOption: [
                {
                    label: "Small",
                    value: "small",
                    fontSize: 12
                },
                {
                    label: "Medium",
                    value: "medium",
                    fontSize: 14
                },
                {
                    label: "Large",
                    value: "large",
                    fontSize: 16
                },
                {
                    label: "Custom",
                    value: "custom",
                    fontSize: 16
                }
            ],
            isCustom: false,
            isSave: true,
            count: 0
        };
    },
    mounted() {
        this.getPortalUrl();
    },
    watch: {
        settings: {
            handler() {
                this.changeCodeURL();
                this.isSave = this.count == 0;
                this.count++;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getPortalUrl() {
            this.isCustom = false;
            this.isSave = true;
            this.isLoading = true;
            this.isNoConfig = false;
            let self = this;
            SettingPetcare.getPortalUrl()
                .then(response => {
                    let resource = response.resource;
                    if (response.code === 200) {
                        this.standalone_url = resource;
                    } else {
                        self.errorMessage();
                    }
                })
                .catch(error => {
                    console.error(error);
                    self.errorMessage();
                })
                .finally(() => {
                    self.getDeliveryConfig();
                });
        },
        getDeliveryConfig() {
            this.count = 0;
            this.isSave = true;
            this.isLoading = true;
            this.isNoConfig = false;
            let self = this;
            SettingPetcare.getDeliveryConfig()
                .then(res => {
                    const { resource, code } = res;
                    if (code === 200 && resource?.settings) {
                        let widgetSetting = find(resource.settings, function (
                            setting
                        ) {
                            return setting?.type === PETCARE_WIDGET;
                        });
                        if (widgetSetting?.data) {
                            this.settings = widgetSetting.data[0];
                            this.isCustom =
                                this.settings.button_size.options == "custom";
                            let button_size = this.settings.button_size;

                            this.btnSizeSelected = {
                                label:
                                    button_size.options
                                        .charAt(0)
                                        .toUpperCase() +
                                    button_size.options.slice(1),
                                value: button_size.options,
                                fontSize: button_size.fontSize
                            };
                        } else {
                            this.settings = {
                                button_color: "#698E3C",
                                font_color: "#FFFFFF",
                                button_size: {
                                    options: "large",
                                    fontSize: 16
                                },
                                label: "Book Appointment",
                                return_url: ""
                            };
                            this.btnSizeSelected = {
                                label: "Large",
                                value: "large",
                                fontSize: 16
                            };
                        }
                    } else {
                        self.errorMessage();
                    }
                })
                .catch(error => {
                    console.error(error);
                    self.errorMessage();
                })
                .finally(() => {
                    self.changeCodeURL();
                    self.isLoading = false;
                });
        },
        copyToClipboard(data) {
            let self = this;
            navigator.clipboard
                .writeText(data)
                .then(() => {
                    self._message("URL copied to clipboard!");
                })
                .catch(err => {
                    console.error("Failed to copy: ", err);
                });
        },
        btnSizeSelect(data) {
            this.btnSizeSelected = data;
            this.settings.button_size.options = data.value;
            this.settings.button_size.fontSize = data.fontSize;
            this.isCustom = data.value == "custom";
        },
        errorMessage() {
            let self = this;
            self._message("Error : Unable to get PetCare Widget", "danger");
            self.isNoConfig = true;
        },
        changeCodeURL() {
            this.code_url = `<a href="${this.standalone_url}" target="_blank"><button class="btn" style="cursor:pointer; border: none; border-radius:4px; padding: 6px 12px; background-color:${this.settings.button_color}; color:${this.settings.font_color}; font-size:${this.settings.button_size.fontSize}px;">${this.settings.label}</button></a>`;
        },
        async save() {
            let valid = await this.$validator.validateAll();
            if (!valid) {
                return false;
            }
            this.isSave = true;
            let params = {
                type: PETCARE_WIDGET,
                settings: this.settings
            };
            SettingPetcare.updateSetting(params)
                .then(response => {
                    if (response.code === 200) {
                        this._message("Successfully update widget");
                    } else {
                        this._message(
                            "Error : Unable to update PetCare Widget",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to update PetCare Widget",
                        "danger"
                    );
                    console.error(error);
                    this.isSave = false;
                })
                .finally(() => {
                    this.getPortalUrl();
                });
        }
    }
};
</script>
